"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EXO_SKELETON_PLACEHOLDER = void 0;
exports.EXO_SKELETON_PLACEHOLDER = '[EXO_SKELETON_PLACEHOLDER]';
//# sourceMappingURL=const.js.map